import React from "react";
import { useTranslation } from "react-i18next";
import { Globe, Check } from "lucide-react";
import { LANGUAGES } from "@/i18n";
import { EXPLICIT_KEY } from "@/i18n/geoLang";
import { clearArabicPreview } from "@/i18n/previewLang";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export const LanguageSwitcher = ({ tone = "ink" }) => {
  const { i18n } = useTranslation();
  const current = i18n.language?.split("-")[0] || "en";
  const textColor = tone === "ivory" ? "text-warm-ivory" : "text-deep-ink";

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        data-testid="language-switcher-trigger"
        className={`inline-flex items-center gap-2 rounded-full px-3 py-2 text-sm font-medium tracking-wide transition-colors hover:text-champagne-gold ${textColor}`}
      >
        <Globe className="h-4 w-4" strokeWidth={1.6} />
        <span className="uppercase">{current}</span>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[10rem] rounded-2xl border-border bg-warm-ivory">
        {LANGUAGES.map((lng) => (
          <DropdownMenuItem
            key={lng.code}
            data-testid={`language-option-${lng.code}`}
            onClick={() => {
              clearArabicPreview();
              try { window.localStorage.setItem(EXPLICIT_KEY, "1"); } catch { /* ignore */ }
              i18n.changeLanguage(lng.code);
            }}
            className="flex cursor-pointer items-center justify-between rounded-xl py-2 text-deep-ink focus:bg-surface-hover"
          >
            <span className={lng.code === "ar" ? "font-arabic" : ""}>{lng.label}</span>
            {current === lng.code && <Check className="h-4 w-4 text-champagne-gold" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
